import { render, staticRenderFns } from "./RegistrosExportacao.vue?vue&type=template&id=1148929a&scoped=true&"
import script from "./RegistrosExportacao.vue?vue&type=script&lang=js&"
export * from "./RegistrosExportacao.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosExportacao.vue?vue&type=style&index=0&id=1148929a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1148929a",
  null
  
)

export default component.exports